export enum InspectionStatusType {
    New = 0,
    AwaitingProjectActivation = 1,
    ProjectActivated = 2,
    InspectionCreated = 3,
    InspectionPending = 4,
    InspectionInProgress = 5,
    InspectionDelivered = 6,
    GraniteInternalStatus = 7,
    Error = 8,
    ResetRequested = 9,
}
